<template>
  <div>
    <vue-headful
    title="Dashboard | Create Account"
    description="Dashboard | Create Account"
/>

<main id="subscribe">
  <a href="/">
    <img src="/logo/logo-white-bg.png" style="width: 220px; float: left; padding: 22px; position: absolute;">
  </a>
  <section class="vh-100 bg-soft d-flex align-items-center">
    <div class="container">
      <div data-background="https://documentify.com/assets/img/illustrations/signin.svg" class="row justify-content-center form-bg-image" style="background-image: url(&quot;https://documentify.com/assets/img/illustrations/signin.svg&quot;);">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="signin-inner mt-3 mt-lg-0 bg-white shadow-soft border border-light rounded p-4 p-lg-5 w-100 fmxw-500">
            <div class="text-center text-md-center mb-4 mt-md-0">
              <h1 class="mb-3 h3">Create Your Account</h1>
              <p class="text-gray">We only need your email address.</p>
            </div>
            <div class="mt-5">
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="far fa-user"></i>
                    </span>
                  </div>
                  <input v-model="email" name="email" placeholder="name@example.com" type="email" class="form-control">
                </div>
              </div>
              <span class="small">Please include an '@' in the email address</span>
              <span v-show="erroremail" class="small" style="display: none; color: rgb(237, 80, 79); font-size: 16px;">Wrong email format.</span>
              <span v-show="usedemail" class="small" style="display: none; color: rgb(237, 80, 79); font-size: 16px;">Email already registered. Use another one for this account.</span>
              <div class="mt-3">
                <button v-show="!creating" @click="create_account" class="btn btn-block btn-primary" style="display: none;">Create Account</button>
                <button v-show="creating" class="btn btn-block btn-primary" style="display: none;">
                  <i class="fas fa-spinner" style="margin: 6px !important;"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

  </div>

</template>

<style>
 @media (min-width: 992px){
.p-lg-5 {
    padding: 6rem 3rem 6rem 3rem !important;
}}
@media (max-width:991px) {
  .form-bg-image{
    background-image: none!important;
  }
}
 </style>

  <script>
  export default {
    props:['propsdata'],
    data() {
      return {
        email: '',
        erroremail: false,
        usedemail: false,
        creating: false
      };
    },
    methods: {
      create_account(){
        this.creating = true;
        axios.post('/dashboard/add-email-to-guest.php', {
          email: this.email
          })
          .then(response => {
            if(response.data == 'error email'){
              this.erroremail = true;
              this.usedemail = false;
              this.creating = false;
                }
            else if(response.data == 'used email'){
              this.erroremail = false;
              this.usedemail = true;
              this.creating = false;
                }
            else{
              window.location.href = "/dashboard/";
            }
        })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    mounted() {
      if(this.propsdata[0].email !== ''){
        window.location.href = "/dashboard/";
      }
    }
  };
  </script>



// WEBPACK FOOTER //
// src/create-account.vue